// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ProgressReportModal_buttons__1uBZG","banner":"ProgressReportModal_banner__3XBFN","progressReportWrapper":"ProgressReportModal_progressReportWrapper__2XR_d"};